// Explicaciones para el usuario final. Los campos se agrupan como aparecen en cada pantalla.
const detail = (row, fields, actions, example) => ({ row, fields, actions, example });
const consultation = [
  "Consultar o actualizar",
  "Vuelve a pedir la información disponible. No crea registros ni corrige datos; cambia lo que estás viendo cuando llegan resultados nuevos.",
];
export const guideDetails = {
  agendamiento: detail(
    "Cada fila representa una actividad programada.",
    [
      [
        "ID y Usuario",
        "El ID es el número que identifica la programación. Usuario indica quién la registró.",
      ],
      [
        "Fecha y Asignado a",
        "Cuándo está programada la actividad y qué técnico es responsable de atenderla.",
      ],
      [
        "Comercio",
        "El lugar donde se realizará el trabajo. La zona, el equipo y la descripción se revisan en el formulario.",
      ],
      [
        "Acciones",
        "Botones para trabajar con esa fila; confirma que corresponda a la actividad correcta.",
      ],
    ],
    [
      ["Crear", "Guarda una programación nueva. No significa que el trabajo ya se haya realizado."],
      [
        "Editar",
        "Cambia los datos de esa programación, por ejemplo fecha o responsable. No crea una segunda actividad.",
      ],
      [
        "Eliminar",
        "Solicita retirar la programación seleccionada. Después de confirmar y recibir el resultado correcto, comprueba que ya no aparezca en la lista.",
      ],
    ],
    "Si una visita cambia de día, busca su ID y edita esa programación en lugar de crearla otra vez."
  ),
  ordenes: detail(
    "La tabla actual muestra cuentas de usuario, aunque el título de la pantalla dice Órdenes de Trabajo.",
    [
      [
        "ID y Usuario",
        "Identifican la cuenta que se muestra en la fila; no identifican una actividad de mantenimiento.",
      ],
      ["Correo, Rol y Estado", "Son los datos de acceso y permisos de esa cuenta."],
      [
        "Acciones",
        "La pantalla tiene acciones vinculadas a usuarios. El texto Resolver agendamiento no garantiza que se esté modificando una orden.",
      ],
    ],
    [
      [
        "Editar o resolver desde esta vista",
        "La pantalla actual envía cambios a la cuenta de usuario seleccionada. No la utilices para dar una actividad por finalizada sin que el administrador confirme el procedimiento.",
      ],
      [
        "Eliminar",
        "La acción está vinculada al usuario de la fila, no a una orden de trabajo. No la confirmes si tu intención es cancelar una actividad.",
      ],
    ],
    "Si necesitas cerrar una orden y ves nombres de usuarios y correos en vez de actividades, solicita ayuda al administrador antes de usar las acciones."
  ),
  configuracion: detail(
    "Cada pestaña tiene su propia lista: comercios, zonas, equipos o tipos de actividad.",
    [
      [
        "Nombre y descripción",
        "Permiten reconocer la opción que después se elegirá al programar una visita.",
      ],
      [
        "Comercio y zona",
        "Ubican las zonas y equipos dentro de un lugar. Evita asociar un equipo a un comercio distinto.",
      ],
      ["Código o localización", "En Comercios ayudan a identificar y ubicar el establecimiento."],
      [
        "Estado y Acciones",
        "Indican la condición del registro y permiten crear, corregir o retirar elementos del catálogo.",
      ],
    ],
    [
      ["Crear", "Agrega una opción al catálogo elegido para utilizarla en la programación."],
      [
        "Editar",
        "Corrige el registro existente. Revisa sus relaciones con comercio y zona antes de guardar.",
      ],
      [
        "Eliminar",
        "Solicita retirar esa opción del catálogo. No equivale a cancelar las actividades ya programadas; revisa el resultado y sus relaciones antes de confirmar.",
      ],
    ],
    "Para programar mantenimiento en una zona nueva, primero revisa que el comercio, la zona y el equipo estén registrados."
  ),
  cierre: detail(
    "Cuando tu rol permite ver el historial, cada fila es un cierre de turno.",
    [
      [
        "Usuario, Caja e ID",
        "Identifican quién cerró, en qué caja y cuál es el comprobante del cierre.",
      ],
      ["Inicio, fin y duración", "Delimitan el turno revisado. No son la fecha de la consulta."],
      [
        "Efectivo inicial, recaudo y efectivo del sistema",
        "Son cantidades distintas: el dinero con el que comenzó la caja, lo recaudado y lo registrado por el sistema.",
      ],
      [
        "Diferencia, tarjeta y total",
        "Permiten comparar el dinero declarado con los valores del sistema. Una diferencia requiere revisión; no significa que la aplicación la haya corregido.",
      ],
    ],
    [
      [
        "Cerrar turno",
        "Envía la información del turno seleccionado para registrar su cierre. La confirmación tiene efecto sobre ese turno, no solo sobre la pantalla.",
      ],
      [
        "Ver detalle o descargar PDF",
        "Permite consultar o conservar un comprobante del cierre. Descargarlo no modifica los valores.",
      ],
    ],
    "Antes de cerrar la caja 2, comprueba usuario, número de turno y horario; no uses únicamente el nombre del usuario para identificarla."
  ),
  vipCame: detail(
    "La vista de vehículos muestra una fila por vehículo; la de grupos resume sus cupos.",
    [
      ["Placa y Grupo", "Identifican el vehículo y el grupo al que pertenece."],
      [
        "Ingresos y salidas general/VIP",
        "Muestran los movimientos reportados en cada zona del parqueadero.",
      ],
      [
        "Estado",
        "Distingue En VIP, En General, Dentro, Fuera y Sin información. Sin información significa que no se pudo confirmar la ubicación; no debes interpretarlo como Fuera.",
      ],
      [
        "Cupos y uso de cupos",
        "En la vista de grupos, comparan los espacios asignados con los ocupados. Total vehículos incluye también los que están fuera.",
      ],
    ],
    [
      consultation,
      [
        "Buscar y filtrar",
        "Combina la búsqueda por placa o grupo con Todos, En VIP, En General, Fuera y Sin información. Al borrar el texto vuelve a verse el listado del filtro elegido; Todos quita el filtro de estado. No envía operaciones al parqueadero.",
      ],
      [
        "Actualizar",
        "Vuelve a consultar los datos del grupo seleccionado o de todos los vehículos. Si falla la ocupación, conserva el listado registrado con estado Sin información y oculta los cálculos de usados y disponibles hasta poder confirmarlos.",
      ],
      [
        "Cambiar grupo o modo de vista",
        "Cambia los vehículos y resúmenes que ves. No mueve un vehículo ni le asigna un cupo nuevo.",
      ],
    ],
    "Un grupo puede tener 20 vehículos registrados y solo 5 dentro; no interpretes los 20 como cupos ocupados."
  ),
  informeDiario: detail(
    "El informe resume los movimientos del día o período consultado.",
    [
      ["Fecha y movimientos", "Ubican las entradas y salidas dentro del período elegido."],
      [
        "Cantidades y totales",
        "Representan el conjunto consultado; un mismo vehículo puede generar más de un movimiento.",
      ],
      ["Detalle disponible", "Permite contrastar el resumen con los registros del informe."],
    ],
    [
      consultation,
      [
        "Cambiar filtros",
        "Selecciona otro período o conjunto de movimientos. No modifica los ingresos ni las salidas registrados.",
      ],
    ],
    "Si comparas dos días, utiliza los mismos filtros para que la diferencia tenga sentido."
  ),
  bicicletas: detail(
    "Cada fila del historial es un ingreso de bicicleta; la pestaña de usuarios tiene una fila por persona.",
    [
      [
        "Usuario",
        "Muestra la persona responsable de la bicicleta. Identificación y contacto ayudan a distinguir personas con el mismo nombre.",
      ],
      [
        "Bicicleta",
        "Muestra su código o serie y color. El color por sí solo no identifica una bicicleta.",
      ],
      [
        "Gancho",
        "Es el espacio asignado. El fondo indica si está disponible u ocupado; la muestra pequeña identifica el color de la bicicleta.",
      ],
      [
        "Entrada, salida y estado",
        "Permiten saber cuándo llegó y si su permanencia terminó. Una fila sin salida puede seguir ocupando un gancho.",
      ],
    ],
    [
      [
        "Crear usuario o bicicleta",
        "Guarda los datos de la persona o de su bicicleta. Todavía debes confirmar el ingreso para registrar su permanencia y asignar gancho.",
      ],
      [
        "Registrar ingreso",
        "Crea el movimiento con ese usuario, esa bicicleta y ese gancho. Revisa los tres datos juntos.",
      ],
      [
        "Registrar salida",
        "Finaliza la permanencia del movimiento seleccionado y permite que el gancho vuelva a estar disponible según la actualización del sistema.",
      ],
      [
        "Editar o eliminar usuario/bicicleta",
        "Editar corrige sus datos; eliminar solicita retirar el registro seleccionado. No lo uses como sustituto de registrar la salida de una bicicleta.",
      ],
    ],
    "Si Ana tiene una bici verde y una azul, selecciona su serie correcta antes de elegir el gancho. Cambiar solo el color no cambia el movimiento por otra bicicleta."
  ),
  frecuencia: detail(
    "Las filas agrupan entradas y salidas por fecha; las columnas distribuyen los movimientos por hora.",
    [
      ["Fecha y Movimiento", "El día consultado y si la fila cuenta entradas o salidas."],
      [
        "Horas",
        "Cada casilla cuenta los movimientos registrados en esa franja horaria; no son minutos de permanencia.",
      ],
      ["Total del día", "Suma los movimientos incluidos para esa fecha y los filtros elegidos."],
    ],
    [
      consultation,
      [
        "Restablecer o descargar",
        "Restablecer vuelve a los filtros iniciales. Descargar conserva el informe; ninguna de estas acciones crea o elimina visitas.",
      ],
    ],
    "Una misma placa que entra dos veces puede aportar dos entradas. El total no siempre representa vehículos distintos."
  ),
  permanencia: detail(
    "Cada fila agrupa visitas terminadas por la fecha en que salieron.",
    [
      [
        "Fecha de salida",
        "El día en que finalizaron las visitas, aunque hayan entrado un día anterior.",
      ],
      [
        "Intervalos de duración",
        "Las columnas 0–15 min, 16–30 min, horas y más de 9 horas cuentan visitas de esa duración. No son horas del reloj.",
      ],
      ["Total general", "Suma las visitas terminadas incluidas en la fila o en el informe."],
    ],
    [
      consultation,
      [
        "Exportar",
        "Descarga el informe consultado. Si hay avisos sobre los datos, la descarga puede identificarse como preliminar. No modifica las visitas.",
      ],
    ],
    "Una visita que entró ayer y salió hoy se cuenta en la fecha de salida de hoy, dentro de su intervalo de duración."
  ),
  usoVip: detail(
    "El informe organiza el uso y el historial del parqueadero VIP.",
    [
      ["Vehículo y placa", "Identifican el vehículo cuyo uso se está consultando."],
      [
        "Entrada y salida",
        "Primer GPIN: general; segundo GPIN posterior: VIP. Primer GPOUT: salida VIP; segundo GPOUT posterior: salida general. Las secuencias ambiguas quedan por revisar.",
      ],
      [
        "Gráfica por placa",
        "Muestra las diez placas con más ingresos VIP en el rango filtrado. La permanencia promedio usa solo entradas con salida VIP disponible.",
      ],
      [
        "Fecha y resumen",
        "Sitúan el uso dentro del período seleccionado. Revisa los registros sin salida antes de considerarlos visitas terminadas.",
      ],
    ],
    [
      consultation,
      [
        "Cambiar período o descargar",
        "Consulta otro conjunto o conserva el informe. No crea vehículos ni cambia sus movimientos.",
      ],
    ],
    "Para saber si un vehículo utilizó VIP el lunes, filtra ese período y revisa sus entradas y salidas, no los cupos del grupo."
  ),
  edificio: detail(
    "Cada fila representa un ciclo de parqueadero: la permanencia de un vehículo entre entrada y salida.",
    [
      ["Placa y número de registro", "Identifican el vehículo y esa visita en particular."],
      ["Host/Cámara", "Es el equipo que reporta el movimiento; no es el propietario del vehículo."],
      [
        "Entrada, salida y duración",
        "Indican cuándo ocurrió la visita y cuánto duró. Comprueba si ya tiene salida.",
      ],
      [
        "Estado y acciones",
        "Distinguen un ciclo activo de uno completado y muestran las acciones habilitadas para tu cuenta.",
      ],
    ],
    [
      ["Nuevo ciclo", "Registra una entrada para la propiedad y vehículo seleccionados."],
      [
        "Cerrar ciclo",
        "Registra la salida del ciclo activo elegido. No borra la entrada ni elimina el vehículo.",
      ],
      [
        "Filtrar o exportar",
        "Solo cambia o descarga los registros que consultas; no crea ni cierra visitas.",
      ],
    ],
    "Si el vehículo ya tiene un ciclo activo, revisa ese movimiento antes de crear otro para la misma visita."
  ),
  administracion: detail(
    "Cada fila corresponde a un usuario o vehículo autorizado en la propiedad seleccionada.",
    [
      ["Placa, tipo y residencial", "Identifican el vehículo y su relación con la propiedad."],
      [
        "Nombre, apellido y cédula",
        "Identifican a la persona asociada; no equivalen a una cuenta de acceso de Goper.",
      ],
      ["Fecha inicio y fin", "Definen la vigencia registrada para la autorización."],
      ["Creado por y estado", "Indican quién registró la autorización y su condición actual."],
    ],
    [
      ["Nuevo usuario", "Agrega una autorización a la propiedad seleccionada."],
      [
        "Editar",
        "Cambia los datos o vigencia del registro existente. Revisa propiedad y placa antes de guardar.",
      ],
      [
        "Eliminar",
        "Solicita retirar la autorización seleccionada. No es un cierre de ciclo ni una eliminación de la cuenta de Goper.",
      ],
    ],
    "Para ampliar una vigencia, busca el registro de esa placa en la propiedad correcta y edítalo en lugar de duplicarlo."
  ),
  propiedades: detail(
    "Cada fila es una propiedad administrada en el sistema.",
    [
      [
        "ID y nombre",
        "Identifican la propiedad; el ID es una referencia interna para distinguirla.",
      ],
      ["IP", "Es la dirección del equipo o sistema asociado a la propiedad."],
      [
        "Descripción e ID copropietario",
        "Aportan contexto y la referencia del responsable o relación de propiedad.",
      ],
      [
        "Creado por, estado y acciones",
        "Muestran quién la registró, si está activa y qué cambios permite tu cuenta.",
      ],
    ],
    [
      ["Nueva propiedad", "Agrega una propiedad para organizar sus usuarios y registros."],
      ["Editar", "Actualiza la información de esa propiedad; no crea una copia."],
      [
        "Activar, desactivar o eliminar",
        "Actúa sobre la propiedad elegida. Desactivar cambia su estado; eliminar solicita retirarla. No supongas que esto borra por sí solo los registros de visitas: revisa el resultado de la acción.",
      ],
    ],
    "Dos propiedades pueden tener nombres parecidos: revisa también el ID y la dirección del equipo antes de modificar una."
  ),
  permisos: detail(
    "Cada fila identifica un usuario y resume sus asignaciones de Copropiedades.",
    [
      ["Usuario", "La cuenta a la que se concederán o retirarán accesos."],
      [
        "Módulos activos y resumen",
        "Muestran las asignaciones existentes. Abre el detalle para comprobar qué propiedades y acciones incluyen.",
      ],
      [
        "Estado y acciones",
        "Permiten revisar la situación del usuario y abrir la gestión de permisos.",
      ],
    ],
    [
      ["Guardar permisos", "Aplica las asignaciones que seleccionaste para ese usuario."],
      [
        "Retirar una asignación",
        "Quita ese acceso del usuario. No elimina la cuenta ni la propiedad.",
      ],
      ["Consultar permisos", "Muestra el alcance actual sin modificarlo."],
    ],
    "Dar acceso a la propiedad A no debe dar acceso a la B: revisa cada asignación antes de guardar."
  ),
  carga: detail(
    "La lista muestra los tags importados y sus datos de identificación y lote.",
    [
      [
        "Números y código QR",
        "Identifican físicamente cada tag. No los sustituyas por una descripción libre.",
      ],
      [
        "Estado y Estado tags",
        "Son campos del archivo de carga; conserva las opciones esperadas por la plantilla.",
      ],
      ["Lote", "Agrupa los tags de una carga o conjunto para encontrarlos después."],
    ],
    [
      [
        "Importar",
        "Envía los registros del Excel para guardarlos. Lee el resultado antes de dar la carga por terminada.",
      ],
      ["Ver lista o filtrar lote", "Consulta lo cargado sin volver a importarlo."],
      [
        "Corregir errores",
        "Corrige el archivo en las filas indicadas. No repitas la carga completa sin revisar qué registros se guardaron.",
      ],
    ],
    "Si aparece un QR duplicado, busca primero ese tag en la lista; cambiar el archivo no elimina el registro existente."
  ),
  cargalazo: detail(
    "Cada fila de la lista es un registro importado para Lazo.",
    [
      ["Placa y comercio", "Identifican el vehículo y establecimiento del registro."],
      [
        "IP del comercio",
        "Es la dirección del equipo asociado; debe corresponder al comercio indicado.",
      ],
      [
        "Nombre, apellido y teléfono",
        "Son los datos de contacto del registro, no los de la persona que carga el archivo.",
      ],
    ],
    [
      ["Importar archivo", "Solicita guardar los registros del Excel después de validarlos."],
      [
        "Consultar o descargar",
        "Permite revisar o conservar los datos guardados sin cargarlos otra vez.",
      ],
    ],
    "Usa la plantilla y verifica que el teléfono esté en su columna; desplazar columnas puede asociar información a una persona equivocada."
  ),
  facturas: detail(
    "Cada fila representa una factura importada.",
    [
      [
        "Número de factura e ID",
        "El número identifica el documento comercial; el ID identifica su registro dentro de la aplicación.",
      ],
      [
        "Empresa, NIT y código empresarial",
        "Indican a quién corresponde la factura y la referencia de la empresa.",
      ],
      [
        "Valor, estado e ID de pago",
        "Muestran el monto registrado, la situación de la factura y su referencia de pago cuando existe.",
      ],
      [
        "Fecha de creación y acciones",
        "Indican cuándo se registró y qué operaciones están disponibles.",
      ],
    ],
    [
      ["Importar", "Crea registros de facturas con estado pendiente a partir del Excel validado."],
      [
        "Editar pendiente",
        "Corrige los datos de la factura seleccionada. Las facturas que ya no están pendientes tienen la edición bloqueada.",
      ],
      [
        "Eliminar pendiente",
        "Solicita retirar esa factura pendiente. No es una devolución ni una anulación bancaria; las no pendientes no permiten esta acción.",
      ],
    ],
    "Si la empresa está mal en una factura pendiente, edita esa factura. No importes otra con la intención de corregir la anterior."
  ),
  recaudo: detail(
    "Cada fila muestra un registro de pago consultado.",
    [
      ["Empresa y NIT", "Identifican a quién corresponde el pago."],
      ["Valor y número de factura", "Relacionan el monto con el documento que se está pagando."],
      [
        "Estado y motivo",
        "Explican el resultado reportado. Aprobado y Conciliado son estados distintos; revisa también el motivo cuando se informa.",
      ],
      [
        "ID pago/link y creación",
        "Permiten identificar la transacción y cuándo se registró. Usa ese ID para distinguir pagos de una misma empresa.",
      ],
    ],
    [
      consultation,
      [
        "Ver comprobante o descargar PDF",
        "Muestra o conserva la información del pago seleccionado. No cobra de nuevo, no cambia su estado ni devuelve dinero.",
      ],
    ],
    "Para comprobar un pago, contrasta número de factura, monto e ID; no basta con que coincida el nombre de la empresa."
  ),
  comercios: detail(
    "El tablero combina resúmenes de actividad y listados de equipos por comercio.",
    [
      ["Comercio y concesión", "Indican el establecimiento o conjunto que estás revisando."],
      [
        "Última lectura y tiempo sin actividad",
        "Muestran cuándo se recibió actividad y cuánto tiempo ha pasado. No son una fecha de apertura del comercio.",
      ],
      [
        "Antenas, peajes o terminales con fallo",
        "Cuentan los elementos reportados con novedad en esa sección.",
      ],
      ["Estado y detalle", "Resumen visual y acceso a los datos que lo explican."],
    ],
    [
      consultation,
      [
        "Abrir detalle o filtrar",
        "Permite investigar la novedad. No edita el comercio ni configura una integración.",
      ],
    ],
    "Si un comercio aparece con fallo, abre su detalle para ver qué equipos lo originan antes de asumir que todos están afectados."
  ),
  tablerogerencial: detail(
    "Cada fila del detalle resume un resultado según la fecha y los filtros de la vista elegida.",
    [
      [
        "Fecha, comercio y pasarela",
        "Ubican el resultado y el medio o plataforma que procesó las transacciones.",
      ],
      [
        "Transacciones, exitosas y fallidas",
        "Son cantidades de operaciones. No representan pesos ni necesariamente clientes distintos.",
      ],
      ["Efectividad", "Es el porcentaje de operaciones exitosas sobre el total de ese grupo."],
      [
        "Monto (COP) y detalle",
        "Muestran el valor monetario y permiten revisar la información que compone el resumen.",
      ],
    ],
    [
      [
        "Cambiar vista y filtros",
        "Recalcula la información mostrada para aceptación o recaudo. No cambia el resultado de las transacciones.",
      ],
      ["Ver detalle", "Permite revisar la base del resumen; no edita ni elimina pagos."],
    ],
    "80 operaciones exitosas de 100 representan 80% de efectividad; ese 80% no es un monto recaudado."
  ),
  infoConcesion: detail(
    "Cada fila es una llave con conciliación para el comercio consultado. El rol Concesiones ve solo su asignación; otros roles con acceso pueden elegir un comercio y consultar sus pasos y novedades, sin abrir ni enviar el formulario de registro.",
    [
      [
        "Llave de conciliación",
        "Identifica el grupo de operaciones que vas a consultar. En Registrar ya está definida y no se puede cambiar.",
      ],
      [
        "Código y concesión",
        "Identifican el comercio de la fila. En el formulario corresponden a la concesión de tu cuenta y no se modifican.",
      ],
      [
        "Cantidad de pasos de la tabla",
        "Es la cantidad de registros conciliados que reporta Gopass para esa llave y comercio. Sirve para consultar; no se muestra en el resumen del formulario ni se copia al campo que debes completar.",
      ],
      [
        "Cantidad de pasos y valor total del formulario",
        "Empiezan vacíos. La concesión debe ingresar sus propios pasos y el valor total de su reporte en pesos colombianos. No se calculan ni se llenan con los valores de la tabla.",
      ],
      [
        "Estado",
        "Por ahora aparece No informado. No debes interpretarlo como aprobado o rechazado.",
      ],
    ],
    [
      [
        "Registrar",
        "Disponible para las cuentas con acceso al módulo cuando la llave no tenga información enviada. Abre el formulario con llave y código fijos. Completa los pasos y el valor de cada peaje asociado a tu concesión; todos son obligatorios. Los campos muestran separadores de miles y los totales se suman automáticamente. Añade la observación y adjunta obligatoriamente el Excel. Registrar desaparece cuando la llave tiene una respuesta enviada. Al pulsar Enviar respuesta se remite el reporte de tu concesión al sistema; cuando se confirme, el formulario se cierra y se muestra automáticamente la respuesta en modo consulta. Si falla, conserva los datos para revisarlos. No edita los pasos conciliados que ves en la tabla ni significa aprobación de la conciliación.",
      ],
      [
        "Ver respuesta",
        "Aparece en las llaves que tengan una respuesta guardada de la concesión. Abre una consulta sin campos editables con la llave, código, pasos y valor reportados, observación, soporte si existe, usuario que la envió y fecha en hora de Colombia. Se recupera al entrar o recargar la página. Los roles de consulta también pueden verla; consultar no vuelve a enviar el reporte ni modifica los pasos conciliados de Gopass.",
      ],
      [
        "Ver Excel",
        "Aparece si la respuesta guardada tiene un soporte. Muestra el nombre original y abre una vista de las celdas de la primera hoja del archivo subido por la concesión. Para mantener la consulta ágil, muestra hasta 1.000 filas y 100 columnas y avisa si hay más datos. Si falla, permite reintentar. Usa el mismo Visualizador de Documentos de Lotes, con lista de archivos y descarga del Excel original. Cerrar el visualizador devuelve a la respuesta sin modificar, eliminar ni reenviar el archivo.",
      ],
      [
        "Documentos de financiera",
        "El icono de carpeta aparece únicamente si la llave tiene comprobantes subidos desde Lotes financiera para esa conciliación y concesión. Abre el visor compartido de Lotes para consultar PDF e imágenes y descargar los archivos. Si no hay documentos, el icono permanece oculto. Actualizar vuelve a consultar su disponibilidad. Esta consulta no sube ni modifica archivos.",
      ],
      [
        "Adjuntar, cambiar o quitar Excel",
        "Es obligatorio. Selecciona un .xlsx o .xls con contenido, de máximo 10 MB. Sin este archivo no puedes enviar la respuesta. Revisa su nombre; puedes reemplazarlo o quitarlo antes de enviar. El archivo se remite junto con tu respuesta al pulsar Enviar respuesta. Cerrar sin enviar descarta la selección.",
      ],
      [
        "Detalle",
        "Muestra los pasos conciliados y las novedades de la llave y comercio seleccionados. El select Llave de conciliación permite filtrar los pasos por el nombre completo informado en los registros; Todas las llaves de conciliación restaura el listado. Puedes combinarlo con la búsqueda y cambiar de página. Si no hay novedades, los pasos siguen visibles. Consultar no crea, edita ni elimina información.",
      ],
      [
        "Actualizar",
        "Vuelve a consultar las llaves del comercio. Si alguna cantidad no pudo consultarse, permite reintentar sin crear registros ni enviar el Excel.",
      ],
    ],
    "Si la tabla muestra 17.841 pasos de Gopass, al pulsar Registrar los campos siguen vacíos. Escribe los pasos y el valor de tu propio reporte, añade una observación y adjunta obligatoriamente tu Excel. Pulsa Enviar respuesta y espera la confirmación. Si falla, conserva los datos para revisarlos. Si se pierde la conexión, verifica si se recibió antes de enviarlo nuevamente."
  ),
  gestionConciliaciones: detail(
    "Cada fila compara cantidades y valores de una fecha y uno o varios peajes.",
    [
      [
        "Día y peajes",
        "Delimitan qué operaciones se comparan. El botón de comentario en la columna Acciones, después de Descuentos, permite escribir una observación de esa fila únicamente si aún no tiene una. La columna Observación muestra el texto guardado antes de Acciones.",
      ],
      [
        "Bloque verde",
        "Peajes, Gopass Pasos Exitosos, Valor concesión y Diferencia Inicial muestran la comparación inicial. En esta tabla los valores de Gopass y de la concesión son importes en pesos.",
      ],
      [
        "Bloque amarillo",
        "Pagos Rechazos, Total Gopass y Diferencia Final permiten revisar el resultado después de los rechazos.",
      ],
      [
        "Bloque azul",
        "Pago financiera, Diferencia Financiera, Valores Adicionales y Descuentos reúnen los importes de la revisión financiera.",
      ],
      [
        "Pasos exitosos y valores",
        "Separa la cantidad de pasos de los importes reportados por Gopass y la concesión.",
      ],
      [
        "Diferencias, rechazos y ajustes",
        "Ayudan a explicar por qué los resultados de ambas partes no coinciden.",
      ],
      [
        "Pago financiera y diferencias",
        "Son valores reportados para revisión; no son botones para transferir dinero.",
      ],
    ],
    [
      [
        "Buscar o exportar Excel",
        "Consulta o descarga la comparación del período. No corrige los importes de origen.",
      ],
      [
        "Escribir observación",
        "Guarda una nota por concesión, fecha y peaje, asociada al usuario de sesión. Si la fila ya tiene observación, el botón queda deshabilitado. Si falla el envío, conserva el texto para revisarlo y reintentar.",
      ],
    ],
    "Una diferencia no se resuelve escribiendo una nota: revisa sus componentes y el origen del valor."
  ),
  configuracionPeajes: detail(
    "La matriz organiza concesiones y los parámetros de sus peajes.",
    [
      [
        "Concesión y peaje",
        "Identifican a qué ubicación pertenecen los parámetros. El nombre del peaje no se cambia aquí.",
      ],
      ["Valores y modalidad", "Definen los parámetros de liquidación mostrados para ese peaje."],
      [
        "Cortes horarios y consolidado",
        "Indican cómo se agrupa el período o la información según la configuración disponible.",
      ],
    ],
    [
      [
        "Editar y guardar parámetros",
        "Actualiza la configuración utilizada para la liquidación. Revisa la concesión y el peaje antes de confirmar.",
      ],
      ["Buscar o actualizar", "Recarga o reduce lo que ves; no cambia por sí solo los parámetros."],
    ],
    "Para ajustar un corte horario, abre el peaje correcto y revisa el horario anterior antes de guardar el nuevo."
  ),
  lotes: detail(
    "La vista principal agrupa registros por llave de conciliación; al filtrar una llave, muestra sus concesiones, registros, estado y acciones. El resumen separa registros, valor total, novedades de abono y ajuste. La llave y el ID comunes aparecen arriba. La tabla tiene un único selector de filas y paginación; Exportar Excel conserva todos los resultados filtrados. Sus detalles muestran lotes y archivos.",
    [
      [
        "ID y llave de conciliación",
        "Identifican el grupo financiero que se está consultando; la llave conecta los registros relacionados.",
      ],
      ["Nombre, archivo y observación", "Ayudan a reconocer la carga y sus notas."],
      [
        "Estado de pago y fecha",
        "Muestran la situación reportada y la fecha asociada al registro.",
      ],
      [
        "Detalle financiera",
        "Puede mostrar placa, transacción, valor inicial, ajustes (cambios al valor), abonos (valores acreditados) y valor a pagar. Son conceptos distintos. La factura y su CUFE permiten identificar el documento electrónico asociado.",
      ],
    ],
    [
      [
        "Importar",
        "Solicita cargar información financiera desde el archivo. Comprueba el resultado antes de repetirla.",
      ],
      [
        "Ver detalle o archivos",
        "Consulta los registros de la llave seleccionada. En el detalle, el select Llave de liquidación filtra los pasos por su nombre completo; Todas las llaves de liquidación restaura el listado y puedes combinarlo con la búsqueda. Abrir un archivo no registra un pago.",
      ],
      ["Filtrar", "Reduce el listado sin borrar los lotes que no coinciden con el filtro."],
    ],
    "Si buscas una carga, usa su llave y fecha; dos archivos con nombres parecidos pueden pertenecer a conciliaciones distintas."
  ),
  lotesFinanciera: detail(
    "Cada fila del listado corresponde a un lote financiero. Al filtrar una llave, la tabla muestra código, concesión, registros, estado y acciones en columnas iguales, con totales en tarjetas de color y una única paginación. Exportar Excel incluye todos los resultados filtrados, aunque estés viendo otra página.",
    [
      [
        "ID y UUID",
        "Son números o códigos de referencia para distinguir el lote. No representan el número de transacciones.",
      ],
      ["Estado, llave y fecha de creación", "Permiten ubicar el lote y su situación reportada."],
      [
        "Concesión, nombre y registros",
        "Identifican el origen y la cantidad de elementos asociados.",
      ],
      [
        "Detalle de valores",
        "El detalle diferencia valor inicial, ajustes (cambios al valor), abonos (valores acreditados) y valor a pagar de cada transacción. Factura y CUFE identifican el documento electrónico asociado; CUFE es su código único.",
      ],
    ],
    [
      [
        "Ver detalle o archivos",
        "Muestra la información de ese lote. El select Llave de liquidación permite filtrar los pasos por nombre completo y volver a Todas las llaves de liquidación. Puedes combinarlo con la búsqueda; no confirma un pago bancario.",
      ],
      ["Buscar o filtrar", "Cambia la lista visible sin crear o eliminar registros financieros."],
    ],
    "Para investigar un valor a pagar, abre su detalle y revisa ajustes y abonos; no lo confundas con el valor inicial."
  ),
  reportes: detail(
    "En Reportes selecciona Pasos rechazados o Correos conciliaciones. Cada fila corresponde a la configuración del reporte seleccionado por comercio; sus destinatarios e historial son independientes.",
    [
      ["Comercio y reporte", "Indican a qué establecimiento corresponde y qué informe se envía."],
      ["Correos configurados", "Son los destinatarios guardados para ese reporte."],
      [
        "Registro de correos",
        "Muestra los envíos registrados y permite revisar el resultado informado por el proveedor.",
      ],
      [
        "Estado y acciones",
        "Indican la condición de la configuración y permiten consultar o gestionar sus correos.",
      ],
    ],
    [
      [
        "Agregar, editar o retirar destinatarios",
        "Cambia la lista guardada para los envíos del reporte. No recupera ni elimina los correos que ya se enviaron.",
      ],
      [
        "Ver registro de correos",
        "Consulta los envíos existentes. Que un envío figure registrado no significa que el destinatario lo haya leído.",
      ],
      consultation,
    ],
    "Si retiras una dirección, verifica la lista guardada. Esa persona puede conservar los correos que recibió antes del cambio."
  ),
  financiera1: detail(
    "Este módulo contiene un informe integrado; las tablas y gráficos pertenecen a ese informe.",
    [
      ["Filtros del informe", "Seleccionan el período o conjunto financiero que se analiza."],
      [
        "Indicadores y tablas",
        "Muestran los resultados que devuelve el informe. Revisa la unidad y el título antes de comparar valores.",
      ],
      ["Detalle", "Cuando está disponible, permite investigar los componentes de un resultado."],
    ],
    [
      [
        "Consultar o cambiar filtros",
        "Modifica la vista del informe; no registra pagos ni elimina información de origen.",
      ],
    ],
    "Antes de comparar dos totales, verifica que ambos usen el mismo período y los mismos filtros."
  ),
  indicadores: detail(
    "En Detalle de tickets, cada fila es una solicitud de atención. Las tarjetas y gráficas resumen los tickets de los filtros aplicados.",
    [
      ["ID, título y categoría", "Identifican la solicitud y describen el tema de la atención."],
      [
        "Estado, prioridad y grupo técnico",
        "Indican su situación actual, urgencia y equipo responsable. El grupo técnico es el equipo de personas que atiende, no un equipo físico.",
      ],
      [
        "Apertura y solución",
        "Son las fechas de creación y solución del ticket. La fecha de solución no se presenta como fecha de cierre.",
      ],
      [
        "Tiempo de solución",
        "Son horas para resolver, cuando existe un dato válido. Un campo sin información no equivale a cero horas.",
      ],
    ],
    [
      [
        "Aplicar filtros",
        "Calcula tarjetas, gráficas y detalle con las fechas de apertura y grupos seleccionados. No cambia los tickets.",
      ],
      [
        "Buscar en el detalle",
        "Cambia las filas visibles de la tabla, pero no reduce la base del PDF o Excel de resumen.",
      ],
      [
        "Exportar",
        "Descarga el informe filtrado con resúmenes y gráficas. No crea, edita ni elimina solicitudes.",
      ],
      consultation,
    ],
    "Si necesitas un informe del equipo NOC de una semana, elige sus fechas y grupo y pulsa Aplicar. Buscar después una palabra en la tabla no cambia ese informe."
  ),
  alertas: detail(
    "Cada fila es un problema que el sistema sigue reportando para un equipo.",
    [
      ["Problema", "Explica qué ocurre; por ejemplo que un reader no responde."],
      [
        "Comercio, equipo e IP",
        "Ubican el establecimiento y el dispositivo afectado. La IP es su dirección en la red.",
      ],
      [
        "Prioridad y fecha",
        "Ayudan a decidir qué revisar primero y desde cuándo se reporta el problema.",
      ],
      [
        "Detalle",
        "Amplía la información. Los datos originales están pensados para apoyar una revisión de soporte.",
      ],
    ],
    [
      ["Ver detalle", "Solo abre la información; no resuelve ni silencia el problema."],
      [
        "Actualizar o esperar actualización",
        "Consulta las alertas actuales. Si el sistema deja de reportar una, la retira del listado.",
      ],
      [
        "Crear, editar o eliminar",
        "Estas acciones no se realizan manualmente aquí. El sistema mantiene las alertas; una crítica conserva su aviso rojo parpadeante mientras se reporte.",
      ],
    ],
    "Si abres una alerta crítica, seguirá destacada. Leerla no significa que el equipo haya vuelto a funcionar."
  ),
  parking: detail(
    "La tabla resume la actividad de comercios y sus terminales de parqueadero.",
    [
      ["Comercio", "Identifica el establecimiento que estás auditando."],
      [
        "Estado",
        "Distingue operativo, falla parcial, fallo total o falta de información según lo reportado.",
      ],
      [
        "Terminales y actividad",
        "Permiten ver qué puntos de entrada o salida tienen movimientos y cuáles requieren revisión.",
      ],
      [
        "Detalle de ciclos",
        "Ayuda a contrastar las visitas y fechas relacionadas con la terminal elegida.",
      ],
    ],
    [
      [
        "Filtrar o abrir detalle",
        "Permite investigar una novedad. No crea entradas ni registra salidas.",
      ],
      consultation,
    ],
    "Si aparece falla parcial, abre el comercio para identificar la terminal afectada antes de asumir que todo el parqueadero falló."
  ),
  redes: detail(
    "Cada fila identifica un switch, es decir, un equipo que conecta otros dispositivos de la red.",
    [
      ["Nombre e IP", "Ubican el equipo; la IP es su dirección de comunicación."],
      [
        "Software",
        "Muestra la información disponible del programa del equipo, cuando el sistema la reporta.",
      ],
      [
        "Automático y puertos",
        "Resume la configuración y los puntos de conexión que muestra el detalle.",
      ],
      [
        "Último intento y acciones",
        "Permiten revisar cuándo se intentó una operación y qué acciones están disponibles para ese equipo.",
      ],
    ],
    [
      consultation,
      [
        "Reiniciar",
        "Envía una orden al equipo o conjunto que indique la confirmación. Puede interrumpir temporalmente su comunicación; verifica el alcance antes de aceptar.",
      ],
      ["Ver detalle", "Muestra información del equipo sin cambiarla."],
    ],
    "Antes de un reinicio, comprueba que la confirmación se refiera al switch correcto y no a un conjunto de equipos."
  ),
  readers: detail(
    "La tabla principal agrupa readers por comercio; el detalle muestra los dispositivos individuales. Un reader es el lector usado en el acceso.",
    [
      ["Grupo y comercio", "Indican a qué establecimiento pertenece el conjunto."],
      ["Tipo de reader", "Distingue la clase de lector configurado."],
      [
        "Readers",
        "Resume los lectores del grupo; abre el detalle para identificar el dispositivo exacto.",
      ],
      [
        "Estado, última información y acciones",
        "Ayudan a revisar si responde y qué operaciones puedes solicitar.",
      ],
    ],
    [
      [
        "Enviar pulso",
        "Solicita una señal al equipo seleccionado. Revisa duración y destino, porque actúa sobre un acceso real.",
      ],
      [
        "Reiniciar",
        "Envía una orden de reinicio al alcance seleccionado. El lector puede tardar en responder; la aplicación bloquea otro reinicio durante 5 minutos.",
      ],
      [
        "Consultar o actualizar",
        "Recarga el estado reportado. No reinicia ni envía pulsos por sí solo.",
      ],
    ],
    "Para reiniciar un solo lector, abre su detalle y verifica el nombre; no confirmes una acción de todo el comercio si solo necesitas ese dispositivo."
  ),
  camaras: detail(
    "Cada fila es una cámara registrada y su información de monitoreo.",
    [
      ["Cámara y comercio", "Identifican el dispositivo y el establecimiento."],
      ["IP/host", "Son referencias para localizar la cámara o su equipo en la red."],
      [
        "Disponibilidad",
        "Con alcance indica respuesta reportada; Sin alcance indica falta de respuesta y Sin verificar indica que no hay una comprobación suficiente.",
      ],
      [
        "Monitoreo y consulta",
        "Muestran la información disponible y permiten pedir métricas del equipo.",
      ],
    ],
    [
      [
        "Consultar equipo",
        "Pide información actual de la cámara. No cambia su configuración ni garantiza que el video tenga buena calidad.",
      ],
      consultation,
    ],
    "Una cámara con alcance puede necesitar revisión de imagen: respuesta del equipo y calidad del video son cosas distintas."
  ),
  creacionCiclo: detail(
    "Cada fila del historial es un intento de registrar una entrada, incluso si fue rechazado.",
    [
      ["Comercio y placa", "Ubican el lugar y el vehículo de la solicitud."],
      [
        "Ingreso y registro del intento",
        "Ingreso es cuándo entró el vehículo; registro del intento es cuándo se envió la solicitud.",
      ],
      ["Usuario y controlador", "Indican quién solicitó y qué sistema o equipo intervino."],
      [
        "Resultado, mensaje y código",
        "Explican si la solicitud fue aceptada o por qué se rechazó. El número del intento no garantiza un ingreso exitoso.",
      ],
    ],
    [
      [
        "Revisar y crear",
        "Envía una solicitud para registrar el ingreso indicado. Solo confirma cuando placa, comercio y horario sean correctos.",
      ],
      ["Ver historial o detalle", "Consulta solicitudes existentes; no las ejecuta otra vez."],
      [
        "Corregir una solicitud rechazada",
        "Revisa el motivo antes de intentar de nuevo. El historial no es un formulario para editar o eliminar visitas existentes.",
      ],
    ],
    "Si se indica que el vehículo ya tiene ciclo, revisa su situación antes de enviar una segunda creación."
  ),
  cerberus: detail(
    "Cada fila es una fuente donde se pueden consultar registros de actividad del sistema, llamados logs.",
    [
      ["Nombre y host", "Identifican la fuente y el equipo al que corresponde."],
      [
        "URL o dirección",
        "Es el lugar desde el que se solicita la información; no es un campo que debas inventar para una consulta.",
      ],
      [
        "Estado",
        "Describe el registro de la fuente, no confirma que estén llegando nuevas líneas.",
      ],
      ["Visor", "Muestra mensajes de actividad conforme se reciben para investigar un problema."],
    ],
    [
      [
        "Abrir o cerrar visor",
        "Empieza o termina la consulta de esa fuente. Cerrar la ventana no apaga el servicio ni borra los mensajes del sistema.",
      ],
      consultation,
    ],
    "Si el visor queda vacío, revisa si conectó y si hay actividad nueva; no concluyas automáticamente que el servicio está caído."
  ),
  placas: detail(
    "Cada fila de esta pantalla corresponde a una consulta realizada para una placa y un comercio.",
    [
      ["Placa y comercio", "Son el vehículo y establecimiento que consultaste."],
      [
        "Cerberus y Poseidon",
        "Son dos sistemas distintos que pueden devolver información o mensajes diferentes.",
      ],
      [
        "Fechas y resultado",
        "Permiten revisar la respuesta recibida para esa consulta, no una garantía de que se haya corregido un ciclo.",
      ],
    ],
    [
      [
        "Consultar placa",
        "Pide información a los sistemas para esos datos. No crea entradas ni cierra visitas.",
      ],
      [
        "Cambiar datos o limpiar",
        "Descarta la consulta anterior de la pantalla. No elimina la placa ni sus movimientos del sistema.",
      ],
    ],
    "Si cambias de comercio, vuelve a consultar: no uses una respuesta de otra sede para decidir qué hacer con el vehículo."
  ),
  comerciosJarvis: detail(
    "Cada fila es la configuración de un comercio para Jarvis, el sistema que ejecuta las reglas configuradas.",
    [
      [
        "ID y comercio",
        "Identifican el establecimiento. El nombre y número provienen del catálogo y no se escriben libremente.",
      ],
      ["Estado y tipo", "Indican si la configuración está activa y la clase de comercio."],
      [
        "Integración",
        "Indica con qué sistema se comunica el comercio. Cuando falta el nombre, puede mostrarse el tipo disponible, como Hardware.",
      ],
      [
        "Apertura CB",
        "Muestra si está habilitada esa opción de apertura en la configuración. Guardarla no es una apertura manual del acceso.",
      ],
    ],
    [
      ["Agregar comercio", "Crea una configuración para un comercio elegido del catálogo."],
      [
        "Editar y confirmar",
        "Actualiza la configuración existente: estado, tipo, integración u opción de apertura. Puede cambiar el comportamiento de las reglas que utilizan esos datos.",
      ],
      [
        "Desactivar",
        "Cambia el estado de la configuración; no equivale a eliminar físicamente el comercio.",
      ],
      consultation,
    ],
    "Si un comercio ya está en la tabla, utiliza Editar. Agregar otro registro no es la forma de corregir su integración."
  ),
  whatsappJarvis: detail(
    "Cada fila indica a qué comercio y terminal pertenece una configuración de avisos por WhatsApp.",
    [
      [
        "Comercio y terminal",
        "El comercio es la sede; la terminal es el punto o equipo de entrada/salida al que aplica la regla.",
      ],
      [
        "Grupo NOC y grupo WhatsApp",
        "El primero organiza la atención; el segundo identifica el destino de los avisos. No son el mismo grupo.",
      ],
      [
        "Workflow",
        "Es el nombre de la regla de trabajo que utilizará Jarvis. Selecciona la que corresponda al caso, sin inventar nombres.",
      ],
      [
        "Estado y pulso",
        "Son opciones de la configuración. Activarlas o desactivarlas cambia la regla; no significa que hayas enviado un mensaje o pulso en ese momento.",
      ],
      [
        "Chat ID",
        "Es la referencia del grupo WhatsApp. Se obtiene del grupo elegido, no es el teléfono de una persona.",
      ],
    ],
    [
      [
        "Agregar configuración",
        "Guarda una regla nueva para el comercio y, cuando corresponde, su terminal.",
      ],
      [
        "Editar y confirmar",
        "Actualiza la regla existente. Revisa especialmente comercio, terminal, grupo NOC, workflow y opciones.",
      ],
      [
        "Desactivar",
        "Cambia el estado de esa configuración; no borra mensajes enviados ni elimina el grupo WhatsApp.",
      ],
      ["Cambiar filtros", "Solo acota las filas visibles. No activa ni desactiva configuraciones."],
    ],
    "Si quieres revisar solo reglas activas sin pulso, combina esos filtros. Eso no modifica las reglas: para hacerlo debes editar y confirmar."
  ),
  copropiedadesW: detail(
    "Cada fila configura los avisos de WhatsApp de un comercio de Copropiedades.",
    [
      ["Comercio y terminal", "Ubican la propiedad o sede y el equipo al que aplica la regla."],
      ["Grupo NOC y WhatsApp", "Diferencian el grupo de atención y el destino de los avisos."],
      ["Workflow", "Es la regla de trabajo seleccionada para ese registro."],
      [
        "Estado y pulso",
        "Son las opciones guardadas de la regla, no el resultado de un mensaje enviado.",
      ],
    ],
    [
      ["Nueva configuración", "Agrega una regla con los datos del formulario."],
      [
        "Editar o cambiar estado",
        "Modifica la configuración existente; revisa el destino y las opciones antes de guardar.",
      ],
      [
        "Filtrar o actualizar",
        "Solo cambia o recarga la consulta. No envía mensajes ni elimina los grupos de WhatsApp.",
      ],
    ],
    "Un grupo NOC correcto no garantiza que el grupo WhatsApp sea el correcto; revisa ambos antes de guardar."
  ),
  rol: detail(
    "Cada fila es un rol, es decir, un conjunto de accesos que se asigna a usuarios.",
    [
      ["ID y rol", "Identifican el conjunto de accesos por número y nombre."],
      ["Módulos habilitados", "Indican a qué pantallas permite entrar ese rol."],
      [
        "Permisos habilitados",
        "Resumen de accesos configurados; abre Editar permisos para revisar su selección.",
      ],
      [
        "Acciones",
        "Permite modificar los permisos de ese rol; no está creando una cuenta de usuario.",
      ],
    ],
    [
      [
        "Crear rol",
        "Agrega un nuevo conjunto de accesos. Después debes asignarlo a una cuenta desde Usuarios para que esa persona lo utilice.",
      ],
      [
        "Editar permisos",
        "Cambia los accesos de las personas que usan ese rol; no solo los del usuario que hace la edición.",
      ],
      [
        "Eliminar",
        "La tabla actual no ofrece eliminación de roles. No desmarques todos los permisos si lo que querías era retirar a una sola persona.",
      ],
    ],
    "Para quitar un módulo a una persona, revisa primero si comparte rol con otras: cambiar ese rol puede afectar a todas."
  ),
  usuario: detail(
    "Cada fila es una cuenta con la que una persona puede acceder a Goper.",
    [
      [
        "ID, usuario y correo",
        "Identifican la cuenta. El correo ayuda a distinguir usuarios con nombres parecidos.",
      ],
      ["Rol", "Es el conjunto de módulos a los que tiene acceso esa persona."],
      [
        "Estado",
        "Muestra si la cuenta está activa o inactiva; no equivale a saber si está conectada en este momento.",
      ],
      ["Acciones", "Permiten editar o solicitar eliminar la cuenta seleccionada."],
    ],
    [
      ["Crear usuario", "Registra una cuenta nueva con el rol y datos indicados."],
      [
        "Editar",
        "Actualiza la cuenta existente. Cambiar el rol cambia su alcance; no cambia los permisos del rol para todos los demás.",
      ],
      [
        "Eliminar",
        "Solicita retirar la cuenta seleccionada. No elimina un rol completo ni sustituye la gestión de una autorización de parqueadero.",
      ],
    ],
    "Si alguien cambia de funciones, revisa la cuenta y su rol antes de crear otra; duplicar cuentas dificulta identificar a la persona."
  ),
};
const cycleDetails = detail(
  "Cada fila del historial es una solicitud de apertura o cierre para un vehículo.",
  [
    ["ID, comercio y placa", "Identifican el intento, el establecimiento y el vehículo."],
    [
      "Terminal",
      "Es el punto de acceso sobre el que se solicita la operación. Una terminal de entrada y una de salida no son intercambiables.",
    ],
    [
      "Fecha de entrada o salida",
      "Indica cuándo ocurrió el movimiento. La fecha de creación indica cuándo se registró la solicitud.",
    ],
    [
      "Usuario, IP y resultado",
      "Indican quién solicitó, el equipo relacionado y el resultado del sistema. Un rechazo también queda en el historial.",
    ],
  ],
  [
    [
      "Confirmar apertura",
      "Solicita registrar la entrada del vehículo con la terminal y horario elegidos.",
    ],
    [
      "Confirmar cierre",
      "Solicita registrar la salida. No es lo mismo que borrar la visita del vehículo.",
    ],
    [
      "Ver historial o detalle",
      "Solo consulta solicitudes anteriores; no las repite ni cambia su resultado.",
    ],
  ],
  "Si la salida ocurrió a las 14:00 pero registras el intento a las 14:10, la fecha de operación y la de creación pueden ser distintas."
);
guideDetails.ciclosAccespark = cycleDetails;
guideDetails.ezytecCiclo = cycleDetails;
export function reconciliationDetails(name) {
  return detail(
    `Las tablas de ${name} agrupan conciliaciones y permiten revisar sus transacciones. Conciliar significa comparar los datos de ambas partes para identificar diferencias.`,
    [
      [
        "Conciliación y estado",
        "Identifican el conjunto revisado y la situación que reporta el sistema.",
      ],
      [
        "Cantidad de transacciones y valor",
        "Cantidad cuenta operaciones; valor muestra pesos. No compares estas dos columnas como si fueran la misma medida.",
      ],
      [
        "Detalle de transacciones",
        "Según la vista puede incluir placa, código de paso, valor pagado, descuentos y otros ajustes.",
      ],
      [
        "Comisiones y novedades",
        "Cuando se muestran, explican cobros, retenciones o diferencias del conjunto consultado. Revisa los títulos porque cada concesión o parqueadero puede presentar datos distintos.",
      ],
    ],
    [
      ["Filtrar y limpiar", "Cambian el conjunto visible; no crean ni eliminan transacciones."],
      [
        "Consultar detalle",
        "Permite investigar el origen de un valor. No aprueba un pago ni corrige los datos por sí solo.",
      ],
    ],
    `Si un valor de ${name} no coincide, selecciona la conciliación y revisa su detalle antes de comparar totales de períodos distintos.`
  );
}

// Ambas pantallas comparten el mismo flujo de gestión de destinatarios.
guideDetails.reportesConciliaciones = guideDetails.reportes;
